import ObscurIALanding from './ObscurIALanding';
function App() { return <ObscurIALanding />; }
export default App;